<template>
   <billsearchinput  ref="billsearchinput" 
                     :url="url" :initForm="initForm" :initTable="initTable"
                     :inputProperty="inputProperty" :propertyObject="propertyObject"
                     label=""></billsearchinput>    
</template>

<script>
import billsearchinput from './../cw_billsearch_input';

export default {
    components:{
        billsearchinput
    },
    props:{
        inputProperty:{
           type:String,
            default:()=>{
                return 'order'
            }
        },
        propertyObject:{
            type:Object,
             default:()=>{
                return {
                    order:'订单 中国加油'
                }
            }
        }
    },
    data(){
        return {
            url:'/purchasemng/purchaseOrder/list',
            initForm:[
                {
                  label:'采购单号',
                  field:'purchaseOrderNo',
                  // value:'value1'
                }
            ],
            initTable:[ 
                    { type: 'radio', title: '序号',width: 70, fixed: null },                  
                    { field: 'purchaseOrderNo', title: '采购单号', width: 200 },
                    { field: 'companyName', title: '公司名', width: 300 },
                    { field: 'supplierDesc', title: '供应商', width: 200 },
                    { field: 'createDate', title: '单据日期', width: 200 }
            ]
        }
    },
    methods:{
        /**
         * 关闭搜索对话框
         */
        closeSearchWindow(){
            this.$refs.billsearchinput.closeSearchWindow();
        },
        openSearchWindow(){
            this.$refs.billsearchinput.openQueryWindow();
        }
    }
    
}
</script>

<style scoped>

</style>